import { Routes } from '@angular/router';
import { appLanguageGuard } from '@app-core/guards/app-language.guard';
import { authGuard } from '@app-core/guards/auth.guard';
import { countryCodeGuard } from '@app-core/guards/country-code.guard';
import { notAuthGuard } from '@app-core/guards/not-auth.guard';
import { rememberRouteGuard } from '@app-core/guards/remember-route.guard';
import { COUNTRY_CODE_ROUTE_PARAM } from '@app-shared/enums/country-codes.enum';
import { RoutePaths } from 'src/app/routes/route-paths.enum';

export const appRoutes: Routes = [
  // {
  //   path: '',
  //   redirectTo: `/${RoutePaths.CountrySelection}`,
  //   pathMatch: 'full',
  // },
  {
    path: RoutePaths.Login,
    loadComponent: () =>
      import('./pages/auth/login/login.component').then(
        component => component.LoginComponent,
      ),
    canActivate: [appLanguageGuard, notAuthGuard],
  },
  {
    path: RoutePaths.RXLogin,
    loadComponent: () =>
      import('./pages/auth/login/components/third-party-login/third-party-login.component').then(
        component => component.ThirdPartyLoginComponent,
      ),
    canActivate: [appLanguageGuard, notAuthGuard],
  },
  {
    path: RoutePaths.MySandozLogin,
    loadComponent: () =>
      import('./pages/auth/login/components/third-party-login/third-party-login.component').then(
        component => component.ThirdPartyLoginComponent,
      ),
    canActivate: [appLanguageGuard, notAuthGuard],
  },
  // {
  //   path: RoutePaths.RXLogin,
  //   loadChildren: () =>
  //     import('./pages/auth/rx-login/rx-login.routes').then(
  //       routes => routes.rxLoginRoutes,
  //     ),
  //   canActivate: [appLanguageGuard, notAuthGuard],
  // },
  {
    path: RoutePaths.Register,
    loadChildren: () =>
      import('./pages/auth/register/register.routes').then(
        routes => routes.registerRoutes,
      ),
    canActivate: [rememberRouteGuard, appLanguageGuard, notAuthGuard],
  },
  {
    path: RoutePaths.ForgotPassword,
    loadChildren: () =>
      import('./pages/auth/forgot-password/forgot-password.routes').then(
        routes => routes.forgotPasswordRoutes,
      ),
    canActivate: [appLanguageGuard, notAuthGuard],
  },
  {
    path: RoutePaths.ResetPassword,
    loadChildren: () =>
      import('./pages/auth/reset-password/reset-password.routes').then(
        routes => routes.resetPasswordRoutes,
      ),
    canActivate: [appLanguageGuard, notAuthGuard],
  },
  {
    path: RoutePaths.ExpiredPassword,
    loadChildren: () =>
      import('./pages/auth/expired-password/expired-password.routes').then(
        routes => routes.expiredPasswordRoutes,
      ),
    canActivate: [appLanguageGuard, notAuthGuard],
  },
  {
    path: RoutePaths.CountrySelection,
    loadChildren: () =>
      import('./pages/country-selection-page/country-selection-page.routes').then(
        routes => routes.countrySelectionRoutes,
      ),
  },
  {
    path: RoutePaths.Verify,
    loadChildren: () =>
      import('./pages/auth/verify/verify.routes').then(m => m.verifyRoutes),
  },
  {
    path: RoutePaths.errorServer,
    loadChildren: () =>
      import('./pages/error-server/error-server.routes').then(
        routes => routes.serverErrorRoutes,
      ),
  },
  {
    path: RoutePaths.UnsubscribeMail,
    loadChildren: () =>
      import('./pages/unsubscribe-mail/unsubscribe-mail.routes').then(
        routes => routes.UnsubscribeMailRoutes,
      ),
  },
  {
    path: `:${COUNTRY_CODE_ROUTE_PARAM}/${RoutePaths.ShortageOverview}`,
    loadChildren: () =>
      import('./pages/shortage-overview/shortage-overview.routes').then(
        routes => routes.shortageOverviewRoutes,
      ),
    canActivate: [
      rememberRouteGuard,
      countryCodeGuard,
      appLanguageGuard,
      authGuard,
    ],
  },
  {
    path: `:${COUNTRY_CODE_ROUTE_PARAM}`,
    children: [
      {
        path: RoutePaths.FAQ,
        loadChildren: () =>
          import('./pages/faq/faq.routes').then(routes => routes.faqRoutes),
        canActivate: [appLanguageGuard, authGuard],
      },
      {
        path: RoutePaths.Users,
        loadChildren: () =>
          import('./pages/admin/users/users.routes').then(m => m.usersRoutes),
        canActivate: [appLanguageGuard, authGuard],
      },
      {
        path: RoutePaths.ConectafarmLogin,
        loadChildren: () =>
          import('./pages/auth/conectafarm-login/conectafarm-login.routes').then(
            routes => routes.conectafarmLoginRoutes,
          ),
      },
      {
        path: RoutePaths.LanguageSelection,
        loadChildren: () =>
          import('./pages/language-selection-page/language-selection-page.routes').then(
            routes => routes.languageSelectionRoutes,
          ),
      },
      {
        path: '**',
        redirectTo: RoutePaths.ShortageOverview,
      },
    ],
    canActivate: [countryCodeGuard],
  },

  {
    path: '**',
    redirectTo: `/${RoutePaths.ShortageOverview}`,
  },
];
